export default __webpack_public_path__ + "../staticImages/favicon-16x16.png";